export enum ItemType {
    Unsupported,
    TestCase,
    TestSuite,
    TestAnalysis,
    SpecificationCoverage,
    SoftwareVersionCoverage,
    TestSpecification,
    EeseCoverage,
}